import * as Actions from 'app/store/actions/ux';

const initialState = {
  isOpen: false,
};

const loading = (state = initialState, action) => {
  switch (action.type) {
    case Actions.OPEN_BACKDROP: {
      return {
        ...state,
        isOpen: true,
        options: {
          ...state.options,
          ...action.options,
        },
      };
    }
    case Actions.CLOSE_BACKDROP: {
      return {
        ...state,
        isOpen: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default loading;
